<template>
    <div class="payCode">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
        />
        <div class="payCode_container">
            <van-field
                v-model="oldPassword"
                :type="typeNameTree"
                :right-icon="imgIconTree"
                @click-right-icon="onClickIconTree"
                maxlength = '6'
                label="原密码"
                placeholder="请输入原密码"
            />
            <van-field
                v-model="newPassword"
                :type="typeName"
                :right-icon="imgIcon"
                @click-right-icon="onClickIcon"
                maxlength = '6'
                label="新密码"
                placeholder="请输入6位数字新密码"
            />
            <van-field
                v-model="confirmPassword"
                :type="typeNameTwo"
                maxlength = '6'
                :right-icon="imgIconTwo"
                placeholder="请再次输入新密码"
                label="确认密码"
                @click-right-icon="onClickIconTwo"
            />
        </div>
        <div class="payCode_btn" @click="onSubmit">确认</div>
        <p class="payCode_forget" @click="forgetPass">忘记密码?</p>
    </div>
</template>

<script>
import Head from '../../../common/head'
import { editPayPass } from '../../api/payment'
import { Toast } from 'vant'
export default {
    name: 'setPayCode',
    components: {
        Head
    },
    data () {
        return {
            headInfo: {
                title: '修改钱包支付密码'
            },
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            imgIcon: 'closed-eye',
            typeName: 'password',
            passwordShaw: false,
            imgIconTwo: 'closed-eye',
            typeNameTwo: 'password',
            passwordShawTwo: false,
            imgIconTree: 'closed-eye',
            typeNameTree: 'password',
            passwordShawTree: false
        }
    },
    watch: {
        oldPassword (newVal, oldVal) {
            if (newVal.length > 6) {
                this.oldPassword = newVal.subString(0, 6)
            } else {
                this.oldPassword = newVal.replace(/[^0-9]/g, '')
            }
        },
        newPassword (newVal, oldVal) {
            if (newVal.length > 6) {
                this.newPassword = newVal.subString(0, 6)
            } else {
                this.newPassword = newVal.replace(/[^0-9]/g, '')
            }
        },
        confirmPassword (newVal, oldVal) {
            if (newVal.length > 6) {
                this.confirmPassword = newVal.subString(0, 6)
            } else {
                this.confirmPassword = newVal.replace(/[^0-9]/g, '')
            }
        }
    },
    methods: {
        onBack () {
            this.$router.back()
        },
        onClickIcon () {
            this.passwordShaw = !this.passwordShaw
            this.typeName = this.passwordShaw ? 'password' : 'text'
            this.imgIcon = this.passwordShaw ? 'closed-eye' : 'eye-o'
        },
        onClickIconTwo () {
            this.passwordShawTwo = !this.passwordShawTwo
            this.typeNameTwo = this.passwordShawTwo ? 'password' : 'text'
            this.imgIconTwo = this.passwordShawTwo ? 'closed-eye' : 'eye-o'
        },
        onClickIconTree () {
            this.passwordShawTree = !this.passwordShawTree
            this.typeNameTree = this.passwordShawTree ? 'password' : 'text'
            this.imgIconTree = this.passwordShawTree ? 'closed-eye' : 'eye-o'
        },
        forgetPass () {
            this.$router.replace({ path: '/b2b/payCode/resetPayCode' })
        },
        async onSubmit () {
            if (!this.oldPassword) {
                Toast('请输入原密码')
                return false
            }
            if (this.oldPassword.length !== 6) {
                Toast('请输入6位原密码')
                return false
            }
            if (!this.newPassword) {
                Toast('请输入新密码')
                return false
            }
            if (this.newPassword.length !== 6) {
                Toast('请输入6位数字新密码')
                return false
            }
            if (!this.confirmPassword) {
                Toast('请输入确认新密码')
                return false
            }
            if (this.confirmPassword.length !== 6) {
                Toast('请输入6位确认新密码')
                return false
            }
            if (this.newPassword !== this.confirmPassword) {
                Toast('两次密码输入不一致')
                return false
            }
            Toast.loading({
                duration: 0,
                message: '提交中...',
                forbidClick: true
            })
            await editPayPass({
                companyCode: this.userInfo.companyCode,
                originPassword: this.oldPassword,
                password: this.newPassword,
                confirmPassword: this.confirmPassword
            })
            Toast({
                message: '修改成功',
                forbidClick: true,
                onClose: () => {
                    this.$router.replace({ path: '/b2b/accountManage/index' })
                }
            })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
}
</script>

<style lang="scss" scoped>
.payCode {
    font-size: 32px;
    &_container {
        color: #000000;
        margin-top: 20px;
        padding-left: 32px;
        background: #ffffff;
    }
    &_btn {
        margin: 64px;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-radius: 96px;
        color: #fff;
        background: #FF7A45;
        &_dis {
            color: #ccc;
            background: #f5f5f5;
        }
    }
    &_forget {
        font-size: 26px;
        color: #999;
        text-align: center;
    }
}
/deep/ .van-cell {
    padding-right: 32px;
}
/deep/ .van-field__label {
    margin-right: 40px;
}
</style>